// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__DwtSp","rotation":"Loader_rotation__zW3DX","light":"Loader_light__qIcrp","dark":"Loader_dark__+V3M8"};